module.exports = __webpack_public_path__ + "static/media/EmergencyItemsIcon.04fb51e8.svg";